import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Divider, Grid, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Convert, ConvertDateToUnixOrNull, FnAxios, FnDialog, I18n, undefinedOrNull } from 'utilities/utilities';
import { APIStatusCode, EnumProjectStatusID, EnumSaveModeProject, I18NextNs } from 'enum/enum';
import { BtnBack, BtnSendRequest } from 'components/Button/ButtonAll';
import { FormProvider, useForm } from 'react-hook-form';
import DataGrid, { PaginationInterface, initRows } from 'components/DataGrid';
import { ApiProject } from 'enum/api';
import { useLocation } from 'react-router';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { SelectItem } from 'components/Input/Select/SelectItem';
import { RadioListItem } from 'components/Input/Radio';
import moment from "moment";

const ModalCommittee = ({ isOpen, setIsOpen, ObjData, onSubmit }) => { //Pop Up > ส่งอนุกรรมการกลั่นกรองฯ ลงคะแนน

    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const location = useLocation();
    
    const [isBtnSendCommittee, setisBtnSendCommittee] = useState(true);
    const [nYear, setnYear] = useState(null);
    const [lstProject, setlstProject] = useState([]);
    const [arrDataCommitteeRoundID, setarrDataCommitteeRoundID] = useState([]);
    const [lstCommitteeRoundUser, setlstCommitteeRoundUser] = useState([]);

    const [loadingTableProject, setloadingTableProject] = useState(null); 
    const [arrSelectProject, setarrSelectProject] = useState([]); 
    const [dataRowProject, setDataRowProject] = useState<PaginationInterface>({...initRows,});

    const [loadingTableCommittee, setloadingTableCommittee] = useState(null); 
    const [dataRowCommittee, setDataRowCommittee] = useState<PaginationInterface>({...initRows,});
    
    useEffect(() => {
        if (isOpen && ObjData !== null) {
            setnYear(ObjData?.nYear);
            setlstProject(ObjData?.lstProject);
            setDataRowProject({
                ...initRows,
                arrRows: ObjData?.lstProject ?? [],
                nDataLength: (ObjData?.lstProject || []).length,
            });
            setarrDataCommitteeRoundID(ObjData?.lstCommitteeRoundID);
            setlstCommitteeRoundUser(ObjData?.lstCommitteeRoundUser);
        }
    }, [isOpen, ObjData])

    const handleClose = () => {
        setIsOpen(false);
        form.reset();
    }

    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            dCommitteeScoreDue: null,
            nCommitteeRoundID: null,
        },
    });

    useEffect(() => {
        if ((arrSelectProject ?? []).length > 0 && form.getValues("dCommitteeScoreDue") !== null && form.getValues("nCommitteeRoundID") !== null) {
            setisBtnSendCommittee(false);
        }else{
            setisBtnSendCommittee(true);
        }
    }, [arrSelectProject, form.watch("dCommitteeScoreDue"), form.watch("nCommitteeRoundID")])
    
    const handleSubmit = (nModeID: EnumSaveModeProject, nStatusID: EnumProjectStatusID) => {
        let lstnProjectID = (arrSelectProject ?? []).map(m => undefinedOrNull(m, "number"));

        let ObjForm = form.getValues();
        let dCommitteeScoreDue = moment(ObjForm.dCommitteeScoreDue);
        let nUnixTimeCommitteeScoreDue = dCommitteeScoreDue.isValid ? ConvertDateToUnixOrNull(dCommitteeScoreDue) : 0;

        let objParam = {
            sLocation: location.pathname,
            nSaveModeProject: nModeID,        
            nStatusID: nStatusID,
            nCommitteeScoreDue: nUnixTimeCommitteeScoreDue,
            lstnProjectID: lstnProjectID,
            nCommitteeRoundID: Convert.StringToInt(ObjForm.nCommitteeRoundID),
        };

        DialogFn.BlockUI();
        AxiosFn.Post(ApiProject.SaveCommitteeNormal, objParam, (result) => {
            DialogFn.UnBlockUI();
            if (result.nStatusCode === APIStatusCode.Success)
            {
                DialogFn.Success(I18n.SetText("Message.SaveApproveComplete", I18NextNs.labelComponent), () => { handleClose(); onSubmit(true); });
            } else {
                DialogFn.Warning(result.sMessage);
            }
        });
    }

    const dataColumnProject: any = [
        {
            field: "sProjectName",
            headerName: `${I18n.SetText("Project.sProjectName")}`,
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 4,            
        },
        {
            field: "sProjectOwner",
            headerName: `${I18n.SetText("Project.sProjectOwner")}`,
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 3,
        },
        {
            field: "nProjectBudget",
            headerName: `${I18n.SetText("Project.sProjectBudget")}`,
            headerAlign: "center",
            align: "right",
            sortable: false,
            flex: 3,
        },
        {
            field: "sStatusName",
            headerName: `${I18n.SetText("Project.sStatus")}`,
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 3,
        },
    ];

    const dataColumnCommittee: any = [
        {
            field: "nOrder",
            headerName: `${I18n.SetText("Project.nNo")}`,
            headerAlign: "center",
            align: "center",
            sortable: false,
            flex: 1,            
        },
        {
            field: "sUserName",
            headerName: `${I18n.SetText("Project.sUserName")}`,
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 5,
        },
        {
            field: "sPositionName",
            headerName: `${I18n.SetText("Project.sPositionName")}`,
            headerAlign: "center",
            align: "left",
            sortable: false,
            flex: 4,
        },
    ];

    return (
        <DialogPreview
            IsOpen={isOpen}
            Title={"ส่งอนุกรรมการกลั่นกรองฯ ลงคะแนน"}
            required={false}
            sMaxWidth="lg"
            onClose={handleClose}
            JsxDialogAction
            CloseSave={false}
            Close={false}
            onCustomButton={
                <Grid container spacing={2} justifyContent={"space-between"} style={{ padding: '1%', paddingBottom: '1%'}}>
                    <Grid item >
                        <BtnBack id={"BtnBack_ModalCommittee"} onClick={handleClose} />
                    </Grid>
                    <Grid item >
                        <BtnSendRequest id={"BtnSend_ModalCommittee"} IsDisabled={isBtnSendCommittee} txt={"ส่งคณะอนุกรรมการกลั่นกรองฯ"} onClick={form.handleSubmit((e) => handleSubmit(EnumSaveModeProject.Submit, EnumProjectStatusID.nStatusID_6),(err) => console.log("err", err))} />
                    </Grid>
                </Grid>
            }
        >
            <Grid container spacing={2} justifyContent={"start"} alignItems={"start"} style={{ padding: '1%', paddingBottom: '1%'}}>        
                <FormProvider {...form}>
                    <Grid item xs={12} md={12} container spacing={2} style={{ paddingBottom: '1%'}}>
                        <Grid item xs={12} md={12} container spacing={1}>
                            <Grid item>
                                <Typography style={{ color: "#225192", fontSize: "16px", fontWeight: 400 }}>กำหนดวันที่คณะอนุกรรมการกลั่นกรองฯข้อเสนอโครงการ และบันทึกผลคะแนน (ภายในวันที่)</Typography>
                            </Grid>
                            <Grid item>
                                <Typography style={{ fontSize: "16px", fontWeight: 400 }} color={'red'}>*</Typography>
                            </Grid>   
                            <Grid item xs={12} md={12}>
                                <Divider style={{ color: "#212836" }} />
                            </Grid>                     
                        </Grid>                        
                        <Grid item xs={12} md={3}>
                            <DatePickerItem
                                id={'dCommitteeScoreDue'}
                                name={'dCommitteeScoreDue'}
                                label={"วันที่"}
                                fullWidth={true}
                                required={true}
                                minDate={new Date()}
                                // maxDate={_dEnd}
                                IsDisablePortal={true}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} md={12} container spacing={1} style={{ paddingBottom: '1%'}}>
                        <Grid item xs={12} md={12}>
                            <Typography style={{ color: "#225192", fontSize: "16px", fontWeight: 400 }}>โปรดเลือกโครงการส่งเพื่อส่งคณะอนุกรรมการกลั่นกรองข้อเสนอโครงการ และบันทึกผลคะแนน</Typography>
                        </Grid >
                        <Grid item xs={12} md={12}>
                            <Divider style={{ color: "#212836" }} />
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1 }}>
                            <DataGrid
                                sTableID='TB_Project_Normal_CommitteeProject'
                                isLoading={loadingTableProject}
                                columns={dataColumnProject}
                                rows={dataRowProject}
                                onLoadData={(e) => {}}
                                isHiddenToolHead={true}
                                isShowCheckBox={true}
                                isHiddenPagination={true}
                                setArrSelect={setarrSelectProject}
                            />
                        </Grid>
                    </Grid>

                    {/* คณะอนุกรรมการประจำปี  : รอบที่  แบบตาราง */}
                    {/* <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12} container spacing={1} justifyContent={"start"} alignItems={"center"}>
                            <Grid item>
                                <Typography style={{ color: "#225192", fontSize: "16px", fontWeight: 400 }}>{"คณะอนุกรรมการประจำปี " + nYear + " : "}</Typography>
                            </Grid>
                            <Grid item xs={4} md={1.5}>
                                <SelectItem
                                    id="nCommitteeRoundID"
                                    name="nCommitteeRoundID"
                                    label={"รอบที่"}
                                    required={true}
                                    options={arrDataCommitteeRoundID}
                                    onChange={(e) => {
                                        let nCommitteeRoundID = e?.value;
                                        let lstCommitteeUser = lstCommitteeRoundUser.find(f=> f.nCommitteeRoundID === nCommitteeRoundID)?.lstCommitteeUser ?? [];
                                        setDataRowCommittee({
                                            ...initRows,
                                            arrRows: lstCommitteeUser,
                                            nDataLength: lstCommitteeUser.length,
                                        });
                                    }}
                                />
                            </Grid>                        
                        </Grid>
                        <Grid item xs={12} sx={{ mt: 1 }}>
                            <DataGrid
                                sTableID='TB_Project_Normal_Committee'
                                isLoading={loadingTableCommittee}
                                columns={dataColumnCommittee}
                                rows={dataRowCommittee}
                                onLoadData={(e) => {}}
                                isHiddenToolHead={true}
                                isShowCheckBox={false}
                                isHiddenPagination={true}
                            />
                        </Grid>
                    </Grid> */}

                    {/* คณะอนุกรรมการประจำปี  : รอบที่ แบบ Radio */}
                    <Grid item xs={12} md={12} container spacing={2}>
                        <Grid item xs={12} md={12} container spacing={1}>
                            <Grid item>
                                <Typography style={{ color: "#225192", fontSize: "16px", fontWeight: 400 }}>{"คณะอนุกรรมการประจำปี " + (nYear !== null ? (nYear + 543) : "")}</Typography>
                            </Grid>
                            <Grid item>
                                <Typography style={{ fontSize: "16px", fontWeight: 400 }} color={'red'}>*</Typography>
                            </Grid>   
                            <Grid item xs={12} md={12}>
                                <Divider style={{ color: "#212836" }} />
                            </Grid>                     
                        </Grid>    
                        <Grid item xs={12} sx={{ mt: 1 }}>
                            {lstCommitteeRoundUser.length > 0 ?
                                <RadioListItem
                                    id={"nCommitteeRoundID"}
                                    name={"nCommitteeRoundID"}
                                    label={"คณะอนุกรรมการประจำปี " + (nYear !== null ? (nYear + 543) : "")}
                                    IsNotShowLabel={true}
                                    required={true}
                                    options={lstCommitteeRoundUser}    
                                    row={false} 
                                    sx={{
                                        alignItems: 'flex-start',
                                        marginBottom: '5%',
                                    }}
                                />
                                :
                                <Typography style={{ fontSize: "16px", fontWeight: 400 }} color={'red'}>{"กรุณาตรวจสอบ ไม่มีข้อมูลคณะอนุกรรมการประจำปี " + (nYear !== null ? (nYear + 543) : "")}</Typography>
                            }
                        </Grid>
                    </Grid>

                </FormProvider>
            </Grid>
        </DialogPreview>
    )
}

export default ModalCommittee
